import { z } from "zod";

import { VerificationResult } from "@/src/models/task-verification";

/**
 * A human ruling on whether an automated sync step produced the correct result. The stable
 * `stepKey` identifies the customer-defined card, while `workflowStepKeys` captures the underlying
 * workflow steps represented by that card when the verdict was recorded.
 */
export const taskStepVerificationSchema = z.object({
  taskId: z.string().uuid(),
  stepKey: z.string().min(1),
  workflowStepKeys: z.array(z.string()),
  verdict: z.nativeEnum(VerificationResult),
  verifiedByUserId: z.string().uuid().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type TaskStepVerification = z.infer<typeof taskStepVerificationSchema>;

export const upsertTaskStepVerificationSchema = z.object({
  stepKey: z.string().trim().min(1).max(100),
  workflowStepKeys: z.array(z.string().trim().min(1).max(100)).max(100).default([]),
  verdict: z.nativeEnum(VerificationResult),
});

export type UpsertTaskStepVerification = z.infer<typeof upsertTaskStepVerificationSchema>;

export const taskStepVerificationListSchema = z.object({
  verifications: z.array(taskStepVerificationSchema),
});
